module.exports = __webpack_public_path__ + "img/tier2_pic2.3bef7d36.png";